import React from "react";
import { Pie, PieChart, ResponsiveContainer } from "recharts";

const AtidimPieChart = ({ device, pieData, types, colors }) => {
  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx,
    cy,
    innerRadius,
    midAngle,
    outerRadius,
    payload,
    percent,
  }) => {
    // const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    // const x = cx + radius * Math.cos(-midAngle * RADIAN);
    // const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + outerRadius * cos;
    const sy = cy + outerRadius * sin;
    const mx = cx + (outerRadius + 1) * cos;
    const my = cy + (outerRadius + 10) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 4;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";
    let name = payload.payload.name.split("\n")[0];
    return (
      <g className="border-2">
        <text
          fontSize={"11px"}
          x={ex + (cos >= 0 ? 1 : -1) * 8}
          y={ey - 22}
          dy={10}
          textAnchor={textAnchor}
          fill={payload.payload.fill}
        >
          {`${name} `}
        </text>
        <text
          fontSize={"11px"}
          x={ex + (cos >= 0 ? 1 : -1) * 8}
          y={ey - 10}
          dy={10}
          textAnchor={textAnchor}
          fill={payload.payload.fill}
        >
          {` ${payload.payload.count} `}
        </text>
        <text
          fontSize={"11px"}
          x={ex + (cos >= 0 ? 1 : -1) * 8}
          y={ey + 2}
          dy={10}
          textAnchor={textAnchor}
          fill={payload.payload.fill}
        >
          {`${parseFloat(percent.toFixed(3) * 100).toFixed(1)}% `}
        </text>
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={payload.payload.fill}
          fill="none"
        />
        <circle
          cx={ex}
          cy={ey}
          r={2}
          fill={payload.payload.fill}
          stroke="none"
        />
      </g>
    );
  };
  let data = pieData.get(device);
  if (!data) {
    return (
      <div className="flex justify-center  ">
        <div className="h-48 w-full py-16">No Data from device</div>
      </div>
    );
  }
  let filteredData = [];
  for (let i = 0; i < types.length; i++) {
    const element = types[i];
    let obj = {};
    obj.name = element;
    let count = data.filter((val) => {
      return val === element;
    });
    obj.count = count.length;
    obj.fill = colors[i];
    filteredData.push(obj);
  }

  return (
    <div
      key={device + 1}
      className="w-48 h-44 flex justify-center items-center  "
    >
      <ResponsiveContainer>
        <PieChart margin={{ top: 15, right: 15, left: 30, bottom: 0 }}>
          <Pie
            data={filteredData}
            dataKey={"count"}
            cx="50%"
            cy="50%"
            outerRadius={55}
            innerRadius={22}
            labelLine={false}
            fill={"fill"}
            label={renderCustomizedLabel}
            paddingAngle={15}
            nameKey="count"
          ></Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
export default AtidimPieChart;
